module.exports = __webpack_public_path__ + "img/CTGi.0c997f46.png";